// src/helpers/propIndex.js
export function norm(s = "") {
  return s
    .toString()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .replace(/\s+/g, " ")
    .trim();
}

function ngrams(source, min = 2, max = 3) {
  const s = norm(source).replace(/ /g, "");
  const out = new Set();
  for (let n = min; n <= max; n++) {
    if (s.length >= n) {
      for (let i = 0; i <= s.length - n; i++) out.add(s.slice(i, i + n));
    }
  }
  return Array.from(out);
}

function tokenize(source) {
  return norm(source)
    .split(" ")
    .filter(w => w.length >= 3);
}

export function buildPropSearchFields(prop = {}) {
  const {
    folio = "",
    nombre = "",
    ubicacion = "",
    tipo = "",
    fraccionamientoId = "",
    fraccionamientoNombre = prop.fraccNombre || "",
    manzana,
    lote,
    codigoHumano = "",
  } = prop;

  const manzanaInt = manzana != null ? Number(manzana) : null;
  const loteInt = lote != null ? Number(lote) : null;

  const claveLote = (fraccionamientoId && manzanaInt != null && loteInt != null)
    ? `${fraccionamientoId}|${manzanaInt}|${loteInt}`
    : "";

  const baseText = [
    folio,
    nombre,
    fraccionamientoNombre,
    ubicacion,
    tipo,
    codigoHumano,
    manzanaInt != null ? `MZ ${manzanaInt}` : "",
    loteInt != null ? `LT ${loteInt}` : "",
  ].filter(Boolean).join(" ");

  const buscadorNgram = Array.from(new Set(ngrams(baseText, 2, 3))).slice(0, 200);
  const buscadorTokens = Array.from(new Set(tokenize(baseText))).slice(0, 200);

  return {
    buscadorNgram,
    buscadorTokens,
    manzanaInt,
    loteInt,
    claveLote,
    fraccNombre: fraccionamientoNombre,
  };
}
